import React, { useContext } from "react";
import { array } from "prop-types";
import { AppContext } from "../AppContext";

function Keywords({ filtered }) {
  const { onClick } = useContext(AppContext);
  const Keywords = filtered.map((item, index) => {
      return (
        <button
          key={index}
          onClick={onClick}
          className="cell small-12 medium-6 large-4 find-a-hotel-suggestion keywords"
          style={{ textAlign: "left" }}
        >
            { <span className="keywords" data-value={item.code}>{item.name}</span>
                }
        </button>
      );
    });

  return Keywords;
}

Keywords.propTypes = {
  filtered: array.isRequired
};

export default Keywords;
